import { CornerMarks } from "@/components/infra";
import { AcademyLockup } from "@/components/academy/AcademyBrand";
import { GRID_BG } from "@/components/academy/AcademyHero";
import { CampusIllustration } from "@/components/academy/CampusIllustration";
import { BuildStatus, PingDot, SoonStamp } from "@/components/academy/teaser/TeaserBits";
import { WaitlistForm } from "@/components/academy/teaser/WaitlistForm";

const TeaserVisual = () => (
  <figure data-testid="academy-teaser-figure" className="lg:col-span-5 relative border border-[rgba(22,9,7,0.18)] bg-white/85 backdrop-blur-sm p-4 sm:p-5 shadow-[0_22px_44px_rgba(70,0,3,0.08),0_2px_6px_rgba(70,0,3,0.08)] fade-up delay-200">
    <CornerMarks />
    <figcaption className="flex items-center justify-between gap-3 mb-3 font-mono-label text-[10px] text-[#5F6168]"><span>Fig. 01 · The Academy campus</span><span className="hidden sm:inline">Under construction</span></figcaption>
    <div className="relative overflow-hidden">
      <CampusIllustration />
      <span aria-hidden="true" className="teaser-scan" />
      <SoonStamp className="absolute right-2 top-2 sm:right-3 sm:top-3" />
    </div>
    <BuildStatus />
  </figure>
);

export const TeaserHero = () => (
  <section data-testid="academy-teaser-hero" aria-labelledby="academy-teaser-title" className="academy-field border-b hairline overflow-hidden" data-chat-safe-area="phone">
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={GRID_BG} />
    <div aria-hidden="true" className="teaser-glow" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-12 pb-16 md:pt-20 md:pb-24 grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-14 items-center">
      <div className="lg:col-span-7 min-w-0">
        <div className="fade-up"><AcademyLockup id="academy-teaser-brand" className="w-[min(68vw,300px)] sm:w-[380px] xl:w-[430px]" /></div>
        <p data-testid="academy-teaser-status" className="mt-10 inline-flex items-center gap-2.5 font-space-mono text-[10px] sm:text-[11px] text-[#3C2A27] fade-up delay-100"><PingDot />In development · launch date to be announced</p>
        <h1 id="academy-teaser-title" data-testid="academy-teaser-headline" className="mt-4 font-orbitron font-black text-[3.1rem] min-[400px]:text-[3.5rem] sm:text-7xl xl:text-[5.5rem] leading-[0.98] tracking-tight text-[#160907]">
          <span className="sr-only">DCYB Academy is </span>
          <span className="teaser-word">Coming</span>
          <span className="teaser-word teaser-fill">Soon</span>
        </h1>
        <p data-testid="academy-teaser-tagline" className="mt-6 font-display text-lg sm:text-2xl text-[#160907] fade-up delay-200">Learn the Industry Behind AI. <span className="text-[#5F6168]">Build Your Place in It.</span></p>
        <p data-testid="academy-teaser-description" className="mt-4 max-w-xl text-base sm:text-lg text-[#3D4049] leading-relaxed fade-up delay-200">Short, practical lessons on how data centers work and the people and businesses behind them, built with the DCYB community. Join the waitlist and be first through the door.</p>
        <WaitlistForm source="academy-hero" testId="academy-waitlist" className="mt-8 max-w-xl fade-up delay-300" />
      </div>
      <TeaserVisual />
    </div>
  </section>
);
